
export {HardwareChipClass};

class HardwareChipClass {
	static readonly FAMILY_ZGM13																	= 0x00;
	static readonly CHIP_ZGM130S037HGN																= 0x01;
	static readonly CHIP_ZGM130S037HGN1																= 0x02;
	
	static readonly FAMILY_EFR32MG21																= 0x01;
	static readonly CHIP_EFR32MG21A010F1024IM32														= 0x01;
	static readonly CHIP_EFR32MG21A010F512IM32														= 0x02;
	static readonly CHIP_EFR32MG21A010F768IM32														= 0x03;
	static readonly CHIP_EFR32MG21A020F1024IM32														= 0x04;
	static readonly CHIP_EFR32MG21A020F512IM32														= 0x05;
	static readonly CHIP_EFR32MG21A020F768IM32														= 0x06;
	static readonly CHIP_EFR32MG21B010F1024IM32														= 0x07;
	static readonly CHIP_EFR32MG21B010F512IM32														= 0x08;
	static readonly CHIP_EFR32MG21B010F768IM32														= 0x09;
	static readonly CHIP_EFR32MG21B020F1024IM32														= 0x0A;
	static readonly CHIP_EFR32MG21B020F512IM32														= 0x0B;
	static readonly CHIP_EFR32MG21B020F768IM32														= 0x0C;
	
	static readonly FAMILY_ZGM23																	= 0x02;
	static readonly CHIP_ZGM230SA27HGN																= 0x01;
	static readonly CHIP_ZGM230SA27HNN																= 0x02;
	static readonly CHIP_ZGM230SB27HGN																= 0x03;
	static readonly CHIP_ZGM230SB27HNN																= 0x04;
	
	static readonly FAMILY_MGM21																	= 0x03;
	static readonly CHIP_MGM210L022JIF																= 0x01;
	static readonly CHIP_MGM210L022JNF																= 0x02;
	static readonly CHIP_MGM210LA22JIF																= 0x03;
	static readonly CHIP_MGM210LA22JNF																= 0x04;
	static readonly CHIP_MGM210P022JIA																= 0x05;
	static readonly CHIP_MGM210P032JIA																= 0x06;
	static readonly CHIP_MGM210PA22JIA																= 0x07;
	static readonly CHIP_MGM210PA32JIA																= 0x08;
	static readonly CHIP_MGM210PB22JIA																= 0x09;
	static readonly CHIP_MGM210PB32JIA																= 0x0A;
	static readonly CHIP_MGM211LA02JNF																= 0x0B;
	
	static readonly FAMILY_EFR32ZG23																= 0x04;
	static readonly CHIP_EFR32ZG23A010F512GM40														= 0x01;
	static readonly CHIP_EFR32ZG23A010F512GM48														= 0x02;
	static readonly CHIP_EFR32ZG23A020F512GM40														= 0x03;
	static readonly CHIP_EFR32ZG23A020F512GM48														= 0x04;
	static readonly CHIP_EFR32ZG23B010F512IM40														= 0x05;
	static readonly CHIP_EFR32ZG23B010F512IM48														= 0x06;
	static readonly CHIP_EFR32ZG23B011F512IM40														= 0x07;
	static readonly CHIP_EFR32ZG23B020F512IM40														= 0x08;
	static readonly CHIP_EFR32ZG23B020F512IM48														= 0x09;
	static readonly CHIP_EFR32ZG23B021F512IM40														= 0x0A;
	
	static readonly FAMILY_EFR32MG24																= 0x05;
	static readonly CHIP_EFR32MG24A010F1024IM40														= 0x01;
	static readonly CHIP_EFR32MG24A010F1024IM48														= 0x02;
	static readonly CHIP_EFR32MG24A010F1536GM40														= 0x03;
	static readonly CHIP_EFR32MG24A010F1536GM48														= 0x04;
	static readonly CHIP_EFR32MG24A010F1536IM40														= 0x05;
	static readonly CHIP_EFR32MG24A010F1536IM48														= 0x06;
	static readonly CHIP_EFR32MG24A010F768IM40														= 0x07;
	static readonly CHIP_EFR32MG24A010F768IM48														= 0x08;
	static readonly CHIP_EFR32MG24A020F1024IM40														= 0x09;
	static readonly CHIP_EFR32MG24A020F1024IM48														= 0x0A;
	static readonly CHIP_EFR32MG24A020F1536GM40														= 0x0B;
	static readonly CHIP_EFR32MG24A020F1536GM48														= 0x0C;
	static readonly CHIP_EFR32MG24A020F1536IM40														= 0x0D;
	static readonly CHIP_EFR32MG24A020F1536IM48														= 0x0E;
	static readonly CHIP_EFR32MG24A020F768IM40														= 0x0F;
	static readonly CHIP_EFR32MG24A021F1024IM40														= 0x10;
	static readonly CHIP_EFR32MG24A110F1024IM48														= 0x11;
	static readonly CHIP_EFR32MG24A110F1536GM48														= 0x12;
	static readonly CHIP_EFR32MG24A111F1536GM48														= 0x13;
	static readonly CHIP_EFR32MG24A120F1536GM48														= 0x14;
	static readonly CHIP_EFR32MG24A121F1536GM48														= 0x15;
	static readonly CHIP_EFR32MG24A410F1536IM40														= 0x16;
	static readonly CHIP_EFR32MG24A410F1536IM48														= 0x17;
	static readonly CHIP_EFR32MG24A420F1536IM40														= 0x18;
	static readonly CHIP_EFR32MG24A420F1536IM48														= 0x19;
	static readonly CHIP_EFR32MG24A610F1536IM40														= 0x1A;
	static readonly CHIP_EFR32MG24A620F1536IM40														= 0x1B;
	static readonly CHIP_EFR32MG24B010F1024IM48														= 0x1C;
	static readonly CHIP_EFR32MG24B010F1536IM40														= 0x1D;
	static readonly CHIP_EFR32MG24B010F1536IM48														= 0x1E;
	static readonly CHIP_EFR32MG24B020F1024IM48														= 0x1F;
	static readonly CHIP_EFR32MG24B020F1536IM40														= 0x20;
	static readonly CHIP_EFR32MG24B020F1536IM48														= 0x21;
	static readonly CHIP_EFR32MG24B110F1536GM48														= 0x22;
	static readonly CHIP_EFR32MG24B110F1536IM48														= 0x23;
	static readonly CHIP_EFR32MG24B120F1536IM48														= 0x24;
	static readonly CHIP_EFR32MG24B210F1536IM40														= 0x25;
	static readonly CHIP_EFR32MG24B210F1536IM48														= 0x26;
	static readonly CHIP_EFR32MG24B220F1536IM48														= 0x27;
	static readonly CHIP_EFR32MG24B310F1536IM48														= 0x28;
	static readonly CHIP_EFR32MG24B610F1536IM40														= 0x29;

	constructor() {
	}
}

